import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Student' },
    { value: 2, label: 'Staff' },
    { value: 3, label: 'School-wide (internal)' },
    { value: 4, label: 'School-wide (public)' },
  ],
});
